$(() => {
  $("#form-pet").on("submit", (e) => {
    // e.preventDefault();
    $("#form-pet").valid();
  });
});
